import { render, staticRenderFns } from "./eleSetting.vue?vue&type=template&id=2d0b381b&scoped=true"
import script from "./eleSetting.vue?vue&type=script&lang=js"
export * from "./eleSetting.vue?vue&type=script&lang=js"
import style0 from "./eleSetting.vue?vue&type=style&index=0&id=2d0b381b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0b381b",
  null
  
)

export default component.exports